import { useEffect, useRef } from 'react';
import Skeleton from 'react-loading-skeleton';
import { map } from 'lodash';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { parseTime } from 'utils/helpers/datetime';

const TableContent = ({
  isFetching,
  disableSeasonalities,
  columns,
  activeColumn,
  data,
}) => {
  const timeTableRef = useRef(null);
  const columnRefs = useRef([]);

  useEffect(() => {
    const columnEl = columnRefs.current[activeColumn];

    if (columnEl) {
      timeTableRef.current?.scrollTo({
        left: columnEl.offsetLeft,
        behavior: 'smooth',
      });
    }
  }, [activeColumn, columns]);
  return (
    <div
      className={classnames('timetable', {
        'timetable--loading': isFetching,
      })}
      ref={timeTableRef}
    >
      <div className="timetable__container">
        <div className="timetable__row">
          {columns.map((column) => (
            <div
              key={column}
              className={classnames('timetable__col p-2', {
                'timetable__col--active': column === activeColumn,
              })}
              ref={(el) => {
                columnRefs.current[column] = el;
              }}
            >
              {column}
            </div>
          ))}
        </div>
        <div className="timetable__row">
          {isFetching ? (
            <>
              {columns.map((column) => (
                <div key={column} className="timetable__col p-2">
                  <Skeleton count={5} height="2.2rem" className="mb-2" />
                </div>
              ))}
            </>
          ) : (
            <>
              {map(data, (column, key) => (
                <div
                  key={key}
                  className={classnames('timetable__col', {
                    'd-flex justify-content-center align-items-center text-grey py-2':
                      !column.length,
                  })}
                >
                  {column.length ? (
                    <>
                      {column.map((item) => {
                        const seasonality =
                          !disableSeasonalities && item.seasonalities?.[0];
                        return (
                          <div
                            key={item.id}
                            className={classnames(
                              'timetable__item d-flex p-2',
                              {
                                'justify-content-between': seasonality,
                                'justify-content-center': !seasonality,
                                'bg-light': item.isLast,
                              }
                            )}
                          >
                            {item.departure_time &&
                              parseTime(item.departure_time)}
                            {seasonality && (
                              <div
                                className={`rounded text-small timetable__seasonality timetable__seasonality--${seasonality.id}`}
                              >
                                {seasonality.name}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </>
                  ) : (
                    <>No Data</>
                  )}
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

TableContent.propTypes = {
  isFetching: PropTypes.bool,
  disableSeasonalities: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.string),
  activeColumn: PropTypes.string,
  data: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        departure_time: PropTypes.string,
        isLast: PropTypes.bool,
        seasonalities: PropTypes.arrayOf(
          PropTypes.shape({ id: PropTypes.number, name: PropTypes.string })
        ),
      })
    )
  ),
};

export default TableContent;
